export default __webpack_public_path__ + "static/media/sound-pause.742ef1ed.png";